<igx-grid #gridPartidas [primaryKey]="'IdPresupuestoPartida'" [data]="partidas" [width]="'100%'" [height]="'100%'"
          [locale]="localGrid" [allowFiltering]="true" [filterMode]="'excelStyleFilter'"
               [rowSelection]="rowSelectionSingle" [selectRowOnClick]="false" [hideRowSelectors]="true" [moving]="true">
  <igx-grid-toolbar>
    <igx-grid-toolbar-title>
      <app-filtro-general #filtroGeneral descripcionLabel="{{ 'MENSAJES.GRALS.ETIQUETA_FILTRO_GRAL' | translate}}" (enterPalabra)="filterInput($event)" (limpiarPalabras)="clearInput()" />
    </igx-grid-toolbar-title>
    <igx-grid-toolbar-actions>
      <igx-grid-toolbar-hiding />
      <igx-grid-toolbar-pinning />
      <app-mas-opciones-grid #masOpcionesG [arrayDatosAVer]="[1, 5]" (opcionSeleccionada)="onSelectionDropDown($event)" />
    </igx-grid-toolbar-actions>
  </igx-grid-toolbar>
  <ng-template igxSortHeaderIcon>
    <igx-icon>north</igx-icon>
  </ng-template>
  <ng-template igxSortAscendingHeaderIcon>
    <igx-icon>north</igx-icon>
  </ng-template>
  <ng-template igxSortDescendingHeaderIcon>
    <igx-icon>south</igx-icon>
  </ng-template>
  <ng-template igxExcelStyleHeaderIcon>
    <igx-icon>filter_alt</igx-icon>
  </ng-template>
  <igx-column field="PartidaWBS" header="WBS" [dataType]="'string'" width="120px"  [resizable]="true" [sortable]="true" [cellStyles]="cellStyles" />
  <igx-column field="Partida" header="{{'GRIDS.PARTIDAS.COL_PARTIDA' | translate}}" [dataType]="'string'" width="210px" [resizable]="true" [hasSummary]="true" [summaries]="'filasSummary' | summaryPipeNeo" [sortable]="true" [cellStyles]="cellStyles" />
  <igx-column field="Renglon" header="{{'GRIDS.PARTIDAS.COL_RENGLON' | translate}}" [dataType]="'number'" width="160px" [sortable]="true" [resizable]="true" [cellStyles]="cellStyles" />
  <igx-column field="DescripcionPartida" header="{{'GRIDS.PARTIDAS.COL_DESCRIPCION' | translate}}" [dataType]="'string'" minWidth="150px" [resizable]="true" [sortable]="true" [cellStyles]="cellStyles" />
  <igx-column field="DescripcionPartidaLarga" header="{{'GRIDS.PARTIDAS.COL_DESCRIPCION_LARGA' | translate}}" [dataType]="'string'" width="260px"  [resizable]="true" [sortable]="true" [hidden]="true" [cellStyles]="cellStyles" />
  <igx-column field="MetrosCuadrados" header="{{'GRIDS.PARTIDAS.COL_METROS2' | translate}}" width="180px" [dataType]="'number'" [editable]="true" [sortable]="true" [resizable]="true" [pipeArgs]="formatDecCantidad" [hidden]="true" />
</igx-grid>
